import Phaser from 'phaser';
import type { GridPoint, PowerUpKind } from '../types';

const SYMBOLS: Record<PowerUpKind, string> = { 'firewall-shield': '⬡', 'bandwidth-boost': '»', 'wifi-extender': '◖◗', 'tech-support': '+', encryption: '2X' };
const SHORT: Record<PowerUpKind, string> = { 'firewall-shield': 'SHIELD', 'bandwidth-boost': 'FIBER BOOST', 'wifi-extender': 'EXTENDER', 'tech-support': 'TECH SUPPORT', encryption: 'COMMUNITY BOOST' };

export class PowerUp extends Phaser.GameObjects.Container {
  constructor(scene: Phaser.Scene, readonly kind: PowerUpKind, readonly cell: GridPoint, x: number, y: number, reducedMotion: boolean, textScale = 1) {
    super(scene, x, y);
    scene.add.existing(this);
    this.setDepth(12);
    const glow = scene.add.circle(0, 0, 34, 0xff8a34, 0.18);
    const plate = scene.add.circle(0, 0, 23, 0x06152f, 1).setStrokeStyle(5, 0xff8a34, 1);
    const symbol = scene.add.text(0, -2, SYMBOLS[kind], { fontFamily: 'Arial Black, Arial', fontSize: `${Math.round(20 * textScale)}px`, fontStyle: 'bold', color: '#ffffff' }).setOrigin(0.5);
    const label = scene.add.text(0, 32, SHORT[kind], { fontFamily: 'Arial Black, Arial', fontSize: `${Math.round(10 * textScale)}px`, color: '#ffffff', backgroundColor: '#020916f2', padding: { x: 5, y: 3 } }).setOrigin(0.5, 0);
    this.add([glow, plate, symbol, label]);
    if (!reducedMotion) {
      scene.tweens.add({ targets: glow, scale: 1.45, alpha: 0.02, duration: 620, yoyo: true, repeat: -1 });
      scene.tweens.add({ targets: this, y: y - 5, duration: 680, yoyo: true, repeat: -1 });
    }
  }
}
